// src/components/UserMenu.js
import { useState } from 'react';
import { Link } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

function UserMenu({ user }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <button
                onClick={handleClick}
                className="flex items-center text-gray-800 hover:text-gray-600"
            >
                <PersonIcon />
                <span className="ml-2">{user || 'User'}</span>
            </button>
            {user && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >

                    <MenuItem onClick={handleClose}>
                        <Link to="/appointments">Upcoming Bookings</Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose}>
                        <Link to="/appointments?past=true">Past Bookings</Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose}>
                        <Link to="/profile">Profile</Link>
                    </MenuItem>
                </Menu>
            )
            }
        </div>
    );
}

export default UserMenu;